import { render, staticRenderFns } from "./about-us.vue?vue&type=template&id=70b444f9&scoped=true&"
import script from "./about-us.js?vue&type=script&lang=js&"
export * from "./about-us.js?vue&type=script&lang=js&"
import style0 from "./about-us.scss?vue&type=style&index=0&id=70b444f9&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b444f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b444f9')) {
      api.createRecord('70b444f9', component.options)
    } else {
      api.reload('70b444f9', component.options)
    }
    module.hot.accept("./about-us.vue?vue&type=template&id=70b444f9&scoped=true&", function () {
      api.rerender('70b444f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/kl-xiaodai/index/component/about-us/about-us.vue"
export default component.exports